export default "__VITE_ASSET__O3$KkLLW__"